import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterEvent } from '@angular/router';
import { throwError } from 'rxjs';
import { AppComponent } from '../app.component';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation.service';
import { Post } from '../core/post';
import { PostService } from '../core/post.service';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'app-day',
  templateUrl: './day.component.html',
  styleUrls: ['./day.component.scss']
})
export class DayComponent implements OnInit {

  message: string = '';
  posts: Post[] = [];
  date: string = '';
  actualDate: Date;
  isMobileView: boolean;

  constructor(
    private route: ActivatedRoute,
    private postService: PostService,
    private dialog: MatDialog,
    private router: Router,
    private confirmationDialogService: ConfirmationDialogService,
    private app: AppComponent) { }

  ngOnInit(): void {
    this.date = this.route.snapshot.paramMap.get('date') || '{}';
    this.getPosts();
    this.actualDate = new Date(this.date);
    this.isMobileView = this.app.getIsMobileView();
  }

  private getPosts(): void {
    this.postService.getAllPostsByDate(this.date).subscribe(data => {
      this.posts = data;
    }, error => {
      throwError(error);
    });
  }

  changePriorUp(id: string, date: string): void {
    this.postService.changePrior(id, date, true).subscribe(data => {
      this.posts = data;
    }, error => {
      throwError(error);
    });
  }

  changePriorDown(id: string, date: string): void {
    this.postService.changePrior(id, date, false).subscribe(data => {
      this.posts = data;
    }, error => {
      throwError(error);
    });
  }

  openDialog(openPost: Post): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    if(this.isMobileView){
      dialogConfig.height = '500px';
    } else {
      dialogConfig.height = '700px';
    }
    
    dialogConfig.data = {
      post: openPost
    }
    this.dialog.open(DialogComponent, dialogConfig);
  }

  toCreate(): void {
    this.router.navigate(['/create-post', this.date]);
  }

  deletePostConfirm(id: string): void {
    this.confirmationDialogService.confirm('Megerősítés munkalap törlésről', 'Biztosan törölni szeretnéd a munkalap bejegyzést?')
      .then((confirmed) => this.deletePost(id, confirmed))
      .catch();
  }

  solvePostConfirm(id: string): void {
    this.confirmationDialogService.confirm('Megerősítés munkalap státusz módosításról', 'Biztosan teljesítettre szeretnéd állítani a munkalap státuszát?','Módosít')
      .then((confirmed) => this.confirmPost(id, confirmed))
      .catch();
  }

  confirmPost(id: string, confirmed: boolean): void {
    if(confirmed){
      this.postService.solvePost(id).subscribe(data => {
        this.posts = data;
        this.message = 'Munkalap státusza sikeresen módosítva teljesítettre!';
      }, error => {
        throwError(error);
      });
    }
  }

  deletePost(id: string, confirmed: boolean): void {
    if (confirmed) {
      this.postService.delete(id).subscribe(data => {
        this.posts = data;
        this.message = 'Munkalap törlése sikeresen megtörtént!';
      }, error => {
        throwError(error);
      });
    }
  }

  toModify(id: string): void {
    this.router.navigate(['/modify', id]);
  }
}
